<template>
  <v-dialog v-model="parent.sendWWEFModal" max-width="600px" persistent scrollable>
    <v-card>
      <v-card-title class="text-h6 white--text px-2 py-1" :class="titleClass">WWEF送付</v-card-title>
      <v-card class="mx-4 my-1 pt-2" outlined elevation="0">
        <v-row no-gutters>
          <v-col class="pb-0" cols="12">
            <v-card-text class="text-start pt-0">以下の内容でメールを送付しますか？</v-card-text>
            <div class="px-4 pb-2">
              <div class="mb-2"><strong>宛先：</strong>{{ wwefConstant?.value2 }}</div>
              <div class="mb-2"><strong>件名：</strong>{{ wwefConstant?.value4 }}</div>
              <div class="mb-2">
                <strong>本文：</strong>
                <div class="mt-1 ml-4" style="white-space: pre-wrap">
                  {{ wwefConstant?.value5 }}
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
      <v-card-actions class="d-flex justify-end">
        <v-btn dense color="primary darken-1" :loading="uploadLoading" @click="handleSendMail"> OK </v-btn>
        <v-btn
          dense
          color="orange darken-1"
          text
          :loading="uploadLoading"
          :disabled="uploadLoading"
          @click="parent.sendWWEFModal = false"
        >
          cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  props: { parent: { type: Object, default: Object, required: true } },
  data() {
    return {};
  },
  methods: {
    ...mapActions({ apiSendWWEFMail: 'api/sendWWEFMail' }),

    // 純粋関数：メール送信データの生成
    createMailData() {
      return {
        from: this.wwefConstant?.value1 || '',
        to: this.wwefConstant?.value2 || '',
        cc: this.wwefConstant?.value3 || '',
        subject: this.wwefConstant?.value4 || '',
        mainText: this.wwefConstant?.value5 || '',
        shippingSeqNumber: this.parent.uploadingRow?.shipping_seq_number || '',
        wwefSentFlag: 1,
      };
    },

    // 純粋関数：メール送信処理
    async handleSendMail() {
      const mailData = this.createMailData();

      // データ検証
      if (!mailData.to || !mailData.subject || !mailData.shippingSeqNumber) {
        throw new Error('必須項目が不足しています。');
      }

      this.parent.sendWWEFMailResult = await this.apiSendWWEFMail(mailData);
      this.parent.sendWWEFModal = false;
    },
  },
  computed: {
    ...mapGetters({
      labels: 'defined/labels',
      error: 'ui/error',
      success: 'ui/success',
      uploadLoading: 'ui/uploadLoading',
      user: 'defined/user',
      constants: 'constantMaster/constantList',
    }),
    titleClass() {
      return { red: this.error, primary: !this.error && !this.success, success: this.success };
    },
    wwefConstant() {
      const baseConstant = this.constants.find((constant) => constant.keyString === 'SEND_WWEF_MAIL');
      const trackingNumber = this.parent.uploadingRow?.tracking_number || '';
      const scheduledShippingDate = this.parent.uploadingRow?.scheduled_shipping_date;

      // 予定出荷日をMM/DD(DOW)形式に変換する純粋関数
      const formatScheduledDate = (dateString) => {
        if (!dateString || typeof dateString !== 'string' || dateString.length !== 8) {
          return 'MM/DD(DOW)'; // フォールバック値
        }

        const year = parseInt(dateString.substring(0, 4), 10);
        const month = parseInt(dateString.substring(4, 6), 10);
        const day = parseInt(dateString.substring(6, 8), 10);

        const date = new Date(year, month - 1, day); // month は0ベース

        // 日付の妥当性チェック
        if (isNaN(date.getTime())) {
          return 'MM/DD(DOW)'; // フォールバック値
        }

        const formattedMonth = String(month).padStart(2, '0');
        const formattedDay = String(day).padStart(2, '0');
        const dayOfWeekNames = ['日', '月', '火', '水', '木', '金', '土'];
        const dayOfWeek = dayOfWeekNames[date.getDay()];

        return `${formattedMonth}/${formattedDay}(${dayOfWeek})`;
      };

      const formattedDate = formatScheduledDate(scheduledShippingDate);

      return {
        ...baseConstant,
        value4: baseConstant?.value4?.replace(/TRACKING_NUMBER/g, trackingNumber) || '',
        value5: baseConstant?.value5?.replace(/MM\/DD\(DOW\)/g, formattedDate).replace(/<br>/g, '\n') || '',
      };
    },
  },
  watch: {},
};
</script>

<style scoped>
div.v-card__text {
  white-space: pre-wrap;
}
</style>
